import { useState, useEffect } from 'react';
import CodeUtil from '../util/CodeUtil';
import { CODE_GROUP_ID } from '../constant/Constant';

const EnrolmentUniversityStatusBox = ({
    enrolmentUniversity: {
        lessonUniversityCd,
        lessonUniversityStudentId,
        enrolmentRegStatusCd,
        lessonUniversityNoticeMsg,
        univEnrolmentRegStatus,
    },
}) => {
    const [universityClassNm, setUniversityClassNm] = useState('');

    useEffect(() => {
        lessonUniversityCd && setUniversityClassNm('univ-logo ' + toLowerCase(lessonUniversityCd));
    }, [lessonUniversityCd]);

    return (
        <div className='univ-status-box'>
            <div className={universityClassNm}></div>
            <div className='gray-tb'>
                <div className='cell-row'>
                    <div className='cell-group'>
                        <div className='cell-label'>개설대학 학번</div>
                        <div className='cell-data'>{lessonUniversityStudentId || '등록 전'}</div>
                    </div>
                    <div className='cell-group'>
                        <div className='cell-label'>수강 처리 상태</div>
                        <div className='cell-data'>
                            <div className='progress'>
                                <span className={getProcessStatusStyle(univEnrolmentRegStatus)}>
                                    {univEnrolmentRegStatus == undefined
                                        ? CodeUtil.getFirstCodeName(CODE_GROUP_ID.UNIV_ENROLMENT_REG_STATUS)
                                        : CodeUtil.getCodeName(
                                              CODE_GROUP_ID.UNIV_ENROLMENT_REG_STATUS,
                                              univEnrolmentRegStatus,
                                          )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cell-row'>
                    <div className='cell-group w-100'>
                        <div className='cell-label'>안내 메세지</div>
                        <div className='cell-data'>{lessonUniversityNoticeMsg}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const toLowerCase = (universityCd) => {
    return universityCd && universityCd.toLowerCase();
};

const getProcessStatusStyle = (status) => {
    switch (status) {
        case 'DONE':
            return 'done';
        default:
            return 'current-p';
    }
};

export default EnrolmentUniversityStatusBox;
